import useDesktopActions from "./useDesktopActions";
import useMobileActions from "./useMobileActions";
import { STEP_GROUP, TUTORIAL_BUTTON_TYPE } from "../../../types";

const useCompanySelectorActions = (
  isCompaniesPage: boolean,
  handleTutorialCompletion: (stepGroup: STEP_GROUP) => Promise<void>
) => {
  const {
    handlePreviousButtonDesktop,
    handleNextButtonDesktop,
  } = useDesktopActions(isCompaniesPage, handleTutorialCompletion);

  const {
    handlePreviousButtonMobile,
    handleNextButtonMobile,
  } = useMobileActions(isCompaniesPage, handleTutorialCompletion);

  const newCompanyCardDesktopButtonActions = (
    buttonType: TUTORIAL_BUTTON_TYPE
  ) => {
    buttonType === TUTORIAL_BUTTON_TYPE.Previous
      ? handlePreviousButtonDesktop()
      : handleNextButtonDesktop();
  };

  const newCompanyCardMobileButtonActions = (
    buttonType: TUTORIAL_BUTTON_TYPE
  ) => {
    buttonType === TUTORIAL_BUTTON_TYPE.Previous
      ? handlePreviousButtonMobile()
      : handleNextButtonMobile();
  };

  return {
    newCompanyCardDesktopButtonActions,
    newCompanyCardMobileButtonActions,
  };
};

export default useCompanySelectorActions;
